import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Password field with a show/hide eye toggle. Accepts every <Input> prop.
export default function PasswordInput({ className, containerClassName, "data-testid": testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className={cn("relative", containerClassName)}>
      <Input {...props} data-testid={testid} type={show ? "text" : "password"} className={cn("pr-10", className)} />
      <button type="button" onClick={() => setShow((v) => !v)} tabIndex={-1}
        data-testid={testid ? `${testid}-toggle` : undefined}
        aria-label={show ? "Hide password" : "Show password"} aria-pressed={show}
        className="absolute right-0 top-0 h-full px-3 grid place-items-center text-slate-400 hover:text-white transition-colors">
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
